'use strict';

angular.module('ecrd.queries')
    .component('queriesListOpen', {
        templateUrl: 'modules/queries/components/open-queries/template.html',
        controller: 'queriesListOpenController',
        require: {
            main: '^queriesMain',
        },
        bindings: {
            'redirect': '&',
        },
    });
